import createSpeechSynthesisPonyfill from './TextToSpeech/createSpeechSynthesisPonyfill.js';

export default createSpeechSynthesisPonyfill;
